import { CalendarCheck, FileText, Megaphone, Trophy } from "lucide-react";

export function NewsIllustration() {
  return (
    <div aria-hidden className="relative hidden h-44 w-44 shrink-0 sm:block sm:h-48 sm:w-48">
      <div className="absolute inset-0 rounded-full bg-commerce-soft" />
      <div className="absolute inset-4 rounded-full bg-commerce/[0.12]" />

      <div className="absolute left-1/2 top-1/2 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-3xl bg-commerce text-commerce-contrast shadow-lg shadow-commerce/30">
        <Megaphone className="h-12 w-12 -rotate-12" strokeWidth={1.75} />
      </div>

      <div className="absolute -left-1 top-6 flex h-12 w-12 items-center justify-center rounded-2xl border border-edge bg-surface text-commerce-ink shadow-panel">
        <FileText className="h-6 w-6" strokeWidth={1.75} />
      </div>
      <div className="absolute -right-1 top-10 flex h-12 w-12 items-center justify-center rounded-2xl border border-edge bg-surface text-commerce-ink shadow-panel">
        <CalendarCheck className="h-6 w-6" strokeWidth={1.75} />
      </div>
      <div className="absolute bottom-3 right-6 flex h-12 w-12 items-center justify-center rounded-2xl border border-edge bg-surface text-accent-orange-ink shadow-panel">
        <Trophy className="h-6 w-6" strokeWidth={1.75} />
      </div>

      <span className="absolute bottom-8 left-5 h-2.5 w-2.5 rounded-full bg-commerce/50" />
      <span className="absolute left-12 top-3 h-2 w-2 rounded-full bg-commerce/40" />
      <span className="absolute right-12 bottom-1 h-2 w-2 rounded-full bg-accent-orange/50" />
    </div>
  );
}
